import React, { PropTypes } from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

const List  = ({ items }) => (
  <Table condensed hover striped>
    <thead>
      <tr>
        <th>#</th>
        <th>Date</th>
        <th>Reference</th>
        <th className="text-right">Debit (Php)</th>
        <th className="text-right">Credit (Php)</th>
        <th className="text-right">Balance (Php)</th>
      </tr>
    </thead>
    <tbody>
      {items.map((item, k) => (
        <tr key={k}>
          <td>{k+1}.</td>
          <td>{item.get('created_date')}</td>
          <td>{item.get('ref')}</td>
          <td className="text-right">{acc.formatNumber(item.get('debit'), 2)}</td>
          <td className="text-right">{acc.formatNumber(item.get('credit'), 2)}</td>
          <td className="text-right">{acc.formatNumber(item.get('balance'), 2)}</td>
        </tr>
      ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan="6"><small className="text-muted">*** NOTHING FOLLOWS ***</small></td>
      </tr>
    </tfoot>
  </Table>
)

List.propTypes = {
  items: PropTypes.object,
}

export default List



// WEBPACK FOOTER //
// ./src/containers/Ledger/list.js